import React from 'react';
import { PropTypes } from 'prop-types';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { get, find } from 'lodash';
import LabelContainer from './components/LabelContainer';
import StyledLabel from './components/StyledLabel';

const StyledSelect = styled(Select)`
  & .Select__control {
    border: thin solid ${({ theme }) => theme.borderColor};
    border-radius: 0;
    height: 40px;

    ${({ error }) => error
      && css`
        border: 3px solid ${({ theme }) => theme.danger};
      `}
  }
  & .Select__indicator-separator {
    display: none;
  }
  & .Select__dropdown-indicator {
    color: ${({ theme }) => theme.primaryColor};
  }
  & .Select__group-heading {
    font-weight: bold;
    color: ${({ theme }) => theme.primaryTextColor};
  }
  & .Select__group {
    padding: 4px 0;
    font-size: 16px;
  }
  & .Select__option--is-selected {
    background-color: ${({ theme }) => theme.primaryColor};
  }
  & .Select__option--is-focused {
    background-color: ${({ theme }) => theme.primaryColor};
  }
`;

const Wrapper = styled.div`
  display: block;
  width: inherit;
`;

const DEFAULT_CONFIG = {
  labelKey: 'value',
  valueKey: 'key',
  menuPlacement: 'auto',
  placeholder: '',
  classNamePrefix: 'Select',
  menuPortalTarget: undefined,
};

const DropdownNext = ({
  error,
  data,
  onChange,
  label,
  star,
  config,
  disabled,
  onClicked,
  value,
}) => {
  const selectConfig = {
    ...DEFAULT_CONFIG,
    ...config,
  };

  return (
    <Wrapper>
      {label && (
        <LabelContainer>
          <StyledLabel>
            <FormattedMessage id={label} />
            {' '}
            {star && <span style={{ color: star }}>*</span>}
          </StyledLabel>
        </LabelContainer>
      )}
      <StyledSelect
        options={data}
        error={error}
        onChange={onChange || onClicked}
        getOptionLabel={item => item[selectConfig.labelKey]}
        getOptionValue={item => item[selectConfig.valueKey]}
        placeholder={selectConfig.placeholder}
        classNamePrefix={selectConfig.classNamePrefix}
        menuPlacement={selectConfig.menuPlacement}
        menuPortalTarget={selectConfig.menuPortalTarget}
        isDisabled={disabled}
        value={value}
        autocomplete="off"
        noOptionsMessage={() => 'Fann ekkert'}
      />
    </Wrapper>
  );
};

DropdownNext.propTypes = {
  config: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  star: PropTypes.string,
  onClicked: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
};

DropdownNext.defaultProps = {
  error: '',
  config: {},
  disabled: false,
  onClicked: () => null,
  label: '',
  star: '',
  value: undefined,
};

export default DropdownNext;
